import { render, staticRenderFns } from "./statsAds.vue?vue&type=template&id=03042a42&"
import script from "./statsAds.vue?vue&type=script&lang=js&"
export * from "./statsAds.vue?vue&type=script&lang=js&"
import style0 from "./statsAds.vue?vue&type=style&index=0&scopped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports